import { Injectable } from '@angular/core';
import { ApiService } from '@app/gateway';
import { BroadcastModel } from '../models';
import { BaseRepository } from './base';
import { FactoryRepository } from './factory';

@Injectable({ providedIn: 'root' })
export class BroadcastRepository extends BaseRepository<BroadcastModel> {
  constructor(
    protected override readonly factoryRepository: FactoryRepository,
    protected override readonly apiService: ApiService
  ) {
    super(factoryRepository, apiService);
  }

  protected getModelName(): string {
    return 'BroadcastFactory';
  }
}
